import { ComponentStyleConfig } from '@chakra-ui/react';

export const Tooltip: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 6,
    padding: 2,
  },
};
